import React, { Component, useState, useEffect } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';
import { GetPropertiesDetails } from '../../request/apiRquest';
import { useParams, useLocation } from 'react-router-dom';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FormatePrice from '../../utils/FormatePrice';

const PropertyDetails = () => {

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  const { id } = useParams();
  //  console.log(id, "idididdd");

  // const location = useLocation();
  const [propertices, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  //  console.log(propertices?.ameneties, "amenetiessss");

  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        id: id?.toString() || "",
      }
      try {
        const response = await GetPropertiesDetails(payload);
        console.log(response, "detailssss");
        setProperties(response);


      } catch (error) {
        console.error("Failed to fetch property details", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  if (loading) {
    return <div className='col-12'> <p>Loading....</p></div>;
  }
  //console.log(propertices);

  if (!propertices) {
    return <div className='col-12'><p>No property details available</p></div>;
  }

  // Mapping through the images array
  const images = propertices.image;

  return <div className="property-details-area">
    <div className="bg-gray pd-top-100 pd-bottom-90">
      <div className="container">
        <div className="row ">
          <div className="col-xl-9 col-lg-8">
            <div className="property-details-slider">
              {images?.length > 1 ? (
                <Slider {...carouselSettings} >
                  {images.map((image, index) => (
                    <div key={index}>
                      <img src={image?.src} alt={imagealt}
                        // style={{ width: "100%", borderRadius: "10px" }}

                        style={{
                          width: '100%',
                          height: 'auto',                // Keeps aspect ratio
                          objectFit: 'cover',            // Crops without stretching
                          borderRadius: '10px',
                          imageRendering: 'auto',        // Important: Let browser choose best rendering
                          display: 'block',              // Removes bottom spacing
                        }}

                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="property-details-slider">
                  <img src={images[0]?.src} alt="property" className="img-fluid"
                    // style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                    style={{
                      height: '400px',
                      objectFit: 'cover',
                      width: '100%',
                      borderRadius: '10px',
                    }}
                  />
                </div>
              )}
            </div>
            <div className="property-details-slider-info">
              <h3>
                {/* <span>AED{propertices.maintainance_cost ?? 0} / mo</span> */}
                 {propertices.building_type ?? "N/A"}</h3>
              <h4>AED {FormatePrice(propertices.price ?? 0)}</h4>
              <h5>Locality Address: {propertices.locality_Address ?? "N/A"}</h5>
              {/* <del>${propertices.price}</del> */}
            </div>
          </div>
          <div className="col-xl-3 col-lg-4">
            <div className="widget widget-owner-info mt-lg-0 mt-5">
              <div className="owner-info text-center">

                <div className="thumb">
                  <img src={propertices?.qr_image} alt="QR Code" />
                </div>
                <div className="details">
                  <h6>QR Image</h6>
                  <span className="designation">Please Scan QR</span>
                  {/* <p className="reviews"><i className="fa fa-star" /><span>4.8</span> 70 Review</p> */}
                </div>
              </div>
              {/* <div className="contact">
                  <h6>Contact Us</h6>
                  <div className="rld-single-input">
                    <input type="text" placeholder="Full Name" />
                  </div>
                  <div className="rld-single-input">
                    <input type="text" placeholder="Email" />
                  </div>
                  <div className="rld-single-input">
                    <input type="text" placeholder="Messages" />
                  </div>
                  <a className="btn btn-yellow" href="#">Send Messages</a>
                </div> */}
              {/* <div className="contact-info">
                  <h6 className="mb-3">Contact Info</h6>
                  <div className="media">
                    <div className="media-left">
                      <img src={ publicUrl+"/assets/img/icons/1.png"} alt={ imagealt } />
                    </div>
                    <div className="media-body">
                      <p>Address</p>
                      <span>Long Island, NY 11355, USA</span>
                    </div>
                  </div>
                  <div className="media">
                    <div className="media-left">
                      <i className="fa fa-phone" />
                    </div>
                    <div className="media-body">
                      <p>Phone</p>
                      <span>+00 111 222 333</span>
                    </div>
                  </div>
                  <div className="media mb-0">
                    <div className="media-left">
                      <i className="fa fa-envelope" />
                    </div>
                    <div className="media-body">
                      <p>Email</p>
                      <span>info@example.com</span>
                    </div>
                  </div>
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row pd-top-90">
        <div className="col-lg-9">
          <div className="property-info mb-5">
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="single-property-info">
                  <h5>Bedrooms</h5>
                  <p><i className="fa fa-bed" />{propertices.number_bedroom}</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="single-property-info">
                  <h5>Bathrooms</h5>
                  <p><i className="fa fa-bath" />{propertices.number_bathroom}</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="single-property-info">
                  <h5>Area</h5>
                  <p><img src={"/assets/img/icons/7.png"} alt={imagealt} />{propertices.builtup_area}ft.</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="single-property-info">
                  <h5>Parking</h5>
                  <p><i className="fa fa-car" />{propertices.coverd_parking} Cover & {propertices.open_parking} Open</p>
                </div>
              </div>
            </div>
          </div>
          <div className="property-news-single-card style-two border-bottom-yellow">
            <h4>Description</h4>
            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In bibendum elit magna, ut placerat nunc tempus vel. Donec vitae dictum ligula. Phasellus congue maximus eleifend. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; 
              Suspendisse potenti. Suspendisse sollicitudin posuere nunc et vehicula.
               Interdum et malesuada fames ac ante ipsum primis in faucibus. 
               Maecenas aliquam vitae quam at sodales. </p> */}
            <p>{propertices.description}</p>
            {/* <a href="#">Read More</a> */}
          </div>
          {/* <div className="property-news-single-card style-two border-bottom-yellow">
              <h4>Base Floor Plan</h4>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5621.1629504770535!2d-122.43633647504856!3d37.748515859182696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2sbd!4v1578304196576!5m2!1sen!2sbd" style={{border: 0}} allowFullScreen />
            </div> */}
          <div className="property-news-single-card border-bottom-yellow">
            <h4>Amenities</h4>
            <div className="row">
              {propertices.ameneties?.length > 0 ? (
                propertices.ameneties.map((amenity, index) => (
                  <div key={index} className="col-sm-4">
                    <ul className="rld-list-style mb-3 mb-sm-0">
                      <li>
                        {/* <i className={amenity.icon} style={{ marginRight: '8px' }}></i> */}
                        <i className="fa fa-check" />
                        {amenity.name}
                      </li>
                    </ul>
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <p>No amenities available.</p>
                </div>
              )}
              {/* ) : (
                <div className="col-12">
                  <p>No amenities available.</p>
                </div>
              )} */}
              {/* <div className="col-sm-4">
                <ul className="rld-list-style mb-3 mb-sm-0">
                  <li><i className="fa fa-check" /> Attic</li>
                  <li><i className="fa fa-check" /> Poll</li>
                  <li><i className="fa fa-check" /> Concierge</li>
                  <li><i className="fa fa-check" /> Basketball Cout</li>
                  <li><i className="fa fa-check" /> Sprinklers</li>
                </ul>
              </div> */}
              {/* <div className="col-sm-4">
                <ul className="rld-list-style mb-3 mb-sm-0">
                  <li><i className="fa fa-check" /> Recreation</li>
                  <li><i className="fa fa-check" /> Front Yard</li>
                  <li><i className="fa fa-check" /> Wine Cellar</li>
                  <li><i className="fa fa-check" /> Basketball Cout</li>
                  <li><i className="fa fa-check" /> Fireplace</li>
                </ul>
              </div> */}
              {/* <div className="col-sm-4">
                <ul className="rld-list-style mb-3 mb-sm-0">
                  <li><i className="fa fa-check" /> Balcony</li>
                  <li><i className="fa fa-check" /> Pound</li>
                  <li><i className="fa fa-check" /> Deck</li>
                  <li><i className="fa fa-check" /> 24x7 Security</li>
                  <li><i className="fa fa-check" /> Indoor Game</li>
                </ul>
              </div> */}
            </div>
          </div>
          {/* <div className="property-news-single-card border-bottom-yellow">
              <h4>Floor Plan</h4>
              <div className="thumb">
                <img src={ publicUrl+"/assets/img/others/10.png"} alt={imagealt} />
              </div>
            </div> */}
          <div className="property-news-single-card border-bottom-yellow pb-3">
            <h4>Property Other Details</h4>
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <i className="fa fa-bed" />
                  </div>
                  <div className="media-body">
                    <h6>Balcony</h6>
                    <p>{propertices.number_balconies}</p>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <i className="fa fa-car" />
                  </div>
                  <div className="media-body">
                    <h6>Garage</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
              <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <img src={"/assets/img/icons/7.png"} alt={imagealt} />
                  </div>
                  <div className="media-body">
                    <h6>Carpet Area</h6>
                    <p>{propertices.carpet_area}sq feet</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <img src={"/assets/img/icons/7.png"} alt={imagealt} />
                  </div>
                  <div className="media-body">
                    <h6>Total floor</h6>
                    <p>{propertices.floor_total}</p>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <img src={"/assets/img/icons/7.png"} alt={imagealt} />
                  </div>
                  <div className="media-body">
                    <h6>Dining Area</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <i className="fa fa-bed" />
                  </div>
                  <div className="media-body">
                    <h6>Bedroom</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <i className="fa fa-bath" />
                  </div>
                  <div className="media-body">
                    <h6>Bathroom</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <img src={"/assets/img/icons/17.png"} alt={imagealt} />
                  </div>
                  <div className="media-body">
                    <h6>Gym Area</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <img src={"/assets/img/icons/17.png"} alt={imagealt} />
                  </div>
                  <div className="media-body">
                    <h6>Gym Area</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          {/* <div className="property-news-single-card border-bottom-yellow mb-0">
              <h4>3D Gallery</h4>
              <div className="thumb">
                <img src={ publicUrl+"/assets/img/others/11.png"}  alt={imagealt} />
              </div>
            </div> */}
        </div>
      </div>
    </div>
  </div>


}

export default PropertyDetails